import { useTranslation } from 'react-i18next';
import React from "react";
import { Button } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailModel";
import { Description } from "@/erp_subpackage/components/YhBox/Description";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";

export const TopButs = ({ modeKey, mode, rowCode, dispatch }) => {
    const { t } = useTranslation();
    const { editFormVal, addFormVal, lookFormVal, setSettleVisible, setWsConfirmVisible, controlled, verifyWhOrShelf } = usePurchaseRoDetailsModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const formVal = mode === "edit" ? editFormVal : mode === "look" ? lookFormVal : addFormVal;


    const action = mode === "edit" ? <>
        <Button
            className="btn-item"
            shape="round"
            disabled={(controlled || editFormVal.status !== DictCodeEnmu.PRO_CREATE)}
            onClick={() => setSettleVisible(true)}
        > {t(`purchase.detail.TopButs.确认结算`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            disabled={controlled || editFormVal.status !== DictCodeEnmu.PRO_SETTLE}
            onClick={() => {
                if (!verifyWhOrShelf()) return false;
                setWsConfirmVisible(true)
            }}
        > {t(`purchase.detail.TopButs.确认出库`)}</Button>
    </> : mode === "look" ? <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => setSettleVisible(true)}
        > {t(`purchase.detail.TopButs.结算查看`)}</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => setWsConfirmVisible(true)}
        > {t(`purchase.detail.TopButs.入库查看`)}</Button>
    </> : false;

    const orderStatus = [
        {
            label: t(`purchase.detail.TopButs.采购退货单`),
            value: formVal.returnCode ?? t(`purchase.detail.TopButs.暂无`),
            color: "blue",
            status: true
        },
        {
            label: t(`purchase.detail.TopButs.状态`),
            value: getTreeNodeName(formVal.status) ?? t(`purchase.detail.TopButs.暂无`),
            color: "green",
            status: true
        }
    ]
    return (
        <YhBox title={orderStatus.map((item, index) => <Description key={index} {...item} />)}
            style={{ padding: "0 20px", marginBottom: "10px" }}
            action={action}
        />
    )
}